import React from "react";
import { Form, Row, Col, Tabs, Tab } from "react-bootstrap";
import { labels } from "../../../../../../localization/labels";
import SubmitButton from "../../../../../core/SubmitButton";
import SubmitControl from "../../../../../core/SubmitControl";
import DropDown from "../../../../../core/DropDown";
import { Affix } from "antd";
import InvolvementRoleTypes from "./InvolvementRoleTypes";
import ProcessComponent from "../../../../../core/ProcessComponent";
import { constants } from "../../../../../../utils/Constants";
import ComponentHeader from "../../../../../core/ComponentHeader/ComponentHeader";

const RoleTypeDetail = props => {
  return (
    <ProcessComponent processes={[constants.OPERATION_SECURITY_ADMINISTRATION]}>
      <div className="container">
        <ComponentHeader
          title={labels.roleType}
          id={props.entity.id}
          showBackButton
        />
        <div className="bordered_bottom_rounded">
          <br></br>
          <Form>
            <Row>
              <Col sm="2">
                <Form.Label className="Label">{labels.name}</Form.Label>
              </Col>
              <Col>
                <Form.Group controlId="name" className="distance-from-tab">
                  <SubmitControl
                    autoFocus
                    type="text"
                    placeholder={labels.namePlaceholder}
                    value={props.entity.name}
                    validationRule={props.validationRules.name}
                    onChange={props.onChange}
                    maxLength={props.maxLength.name}
                  ></SubmitControl>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm="2">
                <Form.Label className="Label">{labels.description}</Form.Label>
              </Col>
              <Col>
                <Form.Group controlId="description">
                  <SubmitControl
                    as="textarea"
                    placeholder={labels.descriptionPlaceholder}
                    value={props.entity.description}
                    onChange={props.onChange}
                    maxLength={props.maxLength.description}
                  ></SubmitControl>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col sm="2">
                <Form.Label className="Label">{labels.dateFromTo}</Form.Label>{" "}
              </Col>
              <Col>
                <Form.Group controlId="dateFromTo">
                  <SubmitControl
                    type="dateRange"
                    placeholder={[
                      labels.dateFromPlaceholder,
                      labels.dateToPlaceholder
                    ]}
                    value={props.entity.dateFromTo}
                    onChange={props.onChange}
                    validationRule={
                      props.validationRules && props.validationRules.dateFromTo
                    }
                    controlId={"dateFromTo"}
                  ></SubmitControl>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm="2">
                <Form.Label className="Label">
                  {labels.partyRoleTypeDiscriminator}
                </Form.Label>
              </Col>
              <Col>
                <Form.Group
                  controlId="partyRoleTypeDiscriminator"
                  className="form-group required"
                >
                  <DropDown
                    value={props.entity.partyRoleTypeDiscriminator}
                    options={props.discriminators.map(x => ({
                      value: x,
                      label: x.name
                    }))}
                    onChange={props.onChange}
                    targetId={"partyRoleTypeDiscriminator"}
                    placeholder={labels.partyRoleTypeDiscriminatorPlaceholder}
                    required={
                      props.validationRules.partyRoleTypeDiscriminator &&
                      props.validationRules.partyRoleTypeDiscriminator.required
                    }
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm="2">
                <Form.Label className="Label">{labels.parent}</Form.Label>
              </Col>
              <Col>
                <Form.Group controlId="parent" className="form-group">
                  <DropDown
                    value={props.entity.parent}
                    options={props.possibleParents.map(x => ({
                      value: x,
                      label: x.name
                    }))}
                    onChange={props.onChange}
                    targetId={"parent"}
                    placeholder={labels.parentPlaceholder}
                    isClearable={true}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
          {props.isNew || !props.entity._links ? null : (
            <div>
              <Tabs id="roles_tabs" className="Tabs">
                <Tab
                  eventKey="involvementRoleType"
                  title={labels.involvementRoleTypes}
                  className="Tab"
                >
                  <InvolvementRoleTypes
                    entityInvolvementRoleTypes={
                      props.entity.involvementRoleTypes
                    }
                    parentInvolvementRoleTypes={
                      props.entity.parentInvolvementRoleTypes
                    }
                    addToTable={props.addToTable}
                    removeFromTable={props.removeFromTable}
                    messageHandler={props.messageHandler}
                    breadcrumbsHandler={props.breadcrumbsHandler}
                  />
                </Tab>
                <Tab
                  eventKey="parentInvolvementRoleTypes"
                  title={labels.parentInvolvementRoleTypes}
                  className="Tab"
                >
                  <InvolvementRoleTypes
                    entityInvolvementRoleTypes={
                      props.entity.parentInvolvementRoleTypes
                    }
                    messageHandler={props.messageHandler}
                    hideActionButtons
                  />
                </Tab>
              </Tabs>
            </div>
          )}
        </div>

        <Affix offsetBottom={true}>
          <div className="bottom_bar">
            {props.isNew ? null : (
              <SubmitButton type="delete" onClick={props.onDelete} showLoader />
            )}
            <SubmitButton
              type="save"
              onClick={props.onSave}
              disabled={props.disabled}
            />
          </div>
        </Affix>
      </div>
    </ProcessComponent>
  );
};

export default RoleTypeDetail;
